import { Container } from "@mui/material";
import { type FC, type ReactNode } from "react";
import { Outlet } from "react-router";

import { Categories } from "~/feature/categories/components/Categories";
import { useActiveCategorySlug } from "~/feature/categories/hooks/useActiveCategorySlug";
import { useCategoryTabs } from "~/feature/categories/hooks/useCategoryTabs";
import { useIsSiteHeaderHidden } from "~/feature/pages/hooks/useIsSiteHeaderHidden";
import { useCategories } from "~/providers/CategoriesProvider";
import { type ICategory } from "~/types/category";

import * as Styled from "./CategoriesLayout.styles";

interface ICategoriesLayoutProps {
  categories: ICategory[];
  children?: ReactNode;
}

export const CategoriesLayout: FC<ICategoriesLayoutProps> = ({
  categories,
  children,
}) => {
  const categoryTabs = useCategoryTabs();
  const slug = useActiveCategorySlug();
  const { categories: clientCategories } = useCategories();
  const displayedCategories = categories.length ? categories : clientCategories;
  const hideSiteHeader = useIsSiteHeaderHidden();

  return (
    <>
      {!hideSiteHeader && (
        <Container maxWidth="xl">
          <Styled.CategoriesWrapper>
            <Categories
              categories={displayedCategories}
              slug={slug}
              categoryTabs={categoryTabs}
            />
          </Styled.CategoriesWrapper>
        </Container>
      )}
      {children ?? <Outlet />}
    </>
  );
};
